import BaseFieldsDrawerController from "./BaseFieldsDrawerController";
import UserNameDrawer from "./UserNameDrawer";
import InvitationDrawer from "./InvitationDrawer";
import $ from "jquery";
import {isEmailValid} from "../../atUtils"
import PageOverlayTipsManager from '../../tips/PageOverlayTipsManager'
import {setEventPreventHidingEditUserSlidingPanel} from '../../panels/utils'

function OnlineAccountFieldsUserPopupDrawer(){}

OnlineAccountFieldsUserPopupDrawer.prototype = new BaseFieldsDrawerController();

OnlineAccountFieldsUserPopupDrawer.prototype.getNewPassword = function(){
    return  null;
};

/**
 * create
 */
export function OnlineAccountFieldsCreateUserPopupDrawer(){}

OnlineAccountFieldsCreateUserPopupDrawer.prototype = new OnlineAccountFieldsUserPopupDrawer();


OnlineAccountFieldsCreateUserPopupDrawer.prototype.initFields = function(){
   $(this.getElementByIdFunction("resendInvitation") ).hide();
   $(this.getElementByIdFunction("resetPasswordLink") ).hide();
};

/**
 * edit
 */
export function OnlineAccountFieldsEditUserPopupDrawer(){}

OnlineAccountFieldsEditUserPopupDrawer.prototype = new OnlineAccountFieldsUserPopupDrawer();

OnlineAccountFieldsEditUserPopupDrawer.prototype.init =function(config){
    OnlineAccountFieldsUserPopupDrawer.prototype.init.call(this, config);
    this.userNameDrawer = new UserNameDrawer().init(config);
    this.invitationDrawer = new InvitationDrawer({
        onDialogContentClick: (e) => setEventPreventHidingEditUserSlidingPanel(e)
    }).init(config);
    this.addDrawer(this.invitationDrawer);
    this.addDrawer(this.userNameDrawer);
    return this;
};

OnlineAccountFieldsEditUserPopupDrawer.prototype.initFields = function(config){
    var accountSettings = config.accountSettings;
    var hire_date = Date.parseJSONDate(accountSettings.hireDate);
    var current_time = Date.parseJSONDate(config.currentTime);
    if( (hire_date.getTime() <= current_time.getTime()) && !accountSettings.activated){
        this.invitationDrawer.setNeedDrawResendButton(true);
    } else {
        this.invitationDrawer.setNeedDrawResendButton(false);
    }
    if(!config.editedUserIsSelf && isEmailValid(accountSettings.email)  && accountSettings.activated){
        this.invitationDrawer.setNeedDrawResetButton(true);
    } else {
        this.invitationDrawer.setNeedDrawResetButton(false);
    }

    OnlineAccountFieldsUserPopupDrawer.prototype.initFields.call(this, config.accountSettings);

    PageOverlayTipsManager.getInstance().refreshDynamicTips(false);
};

OnlineAccountFieldsEditUserPopupDrawer.prototype.updateAccountSettings = function(accountSettings) {
    this.invitationDrawer.initFields(accountSettings)
}



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/OnlineAccountFieldsUserPopupDrawer.js